// Config for the AgentCore front-door proof-of-concept.
//
// This exists as a SEPARATE environment on purpose. The obvious shortcut is to
// flip features.useHttpStreaming in apiConfigDev.js, but apiConfigDev is what
// `npm run build:dev` compiles and what the GitLab dev pipeline ships to
// https://dev.iq.pay.tnsi.com. That distribution has no /api/* behaviour, so
// enabling the front door there would point live dev chat at a path that does
// not exist and break it for real users.
//
// Build with:  npm run build:poc
// Deploy to:   the PoC frontend bucket (FrontendBucketName stack output)
// Serve from:  the PoC CloudFront distribution (ApiDomain stack output)
//
// Everything except apiBaseUrl.agentApi, features and cognito.logoutUri is
// identical to apiConfigDev.js, because the PoC reuses the same Cognito pool,
// logging API and checkout endpoints as dev.
module.exports = {
  apiBaseUrl: {
    logApi: "https://5n7h3e1iq8.execute-api.us-east-1.amazonaws.com/Prod",
    logApiID: "mlPMtlAbgj6xbKACmJp9iaQQs0nYeY941LHghrX0",
    claudeApi: "https://5n7h3e1iq8.execute-api.us-east-1.amazonaws.com/Prod",
    claudeApiID: "mlPMtlAbgj6xbKACmJp9iaQQs0nYeY941LHghrX0",

    // EMPTY IS CORRECT. The PoC distribution serves this SPA at / and the
    // agent API at /api/*, so an empty base makes the adapter issue a relative,
    // same-origin request to /api/ask: no CORS, no preflight, and the session
    // cookie stays first-party so SameSite=Strict still sends it.
    //
    // Do not paste the distribution domain here. It would work today and break
    // the moment a custom domain is put in front.
    agentApi: "",
  },
  features: {
    useKendraAPI: true,
    // The point of this config.
    useHttpStreaming: true,
    // Sign in through the front door rather than oidc-client-ts. The front
    // door runs the OAuth flow with state + PKCE and keeps the tokens
    // server-side, so the browser holds only an httpOnly session cookie and
    // never a token. See src/auth/session.js. Set to false to go back to
    // oidc-client-ts and bearer tokens, which the front door still accepts.
    useBffSession: true,
  },
  cognito: {
    // Same pool as dev.
    authority:
      "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_bhsE2FqD8",
    clientId: "12comhftbdd0tq6n1o0kcto1rq",
    cognitoDomain: "https://dev-tnspay-iq-auth.auth.us-east-1.amazoncognito.com",

    // NOTE: sign-in will fail until the front door's callback URL is
    // registered on the Cognito app client. With useBffSession the front door
    // sends Cognito redirect_uri=https://<ApiDomain>/api/auth/callback (the
    // CognitoCallbackUrlToRegister stack output), not the SPA's /ask. That is
    // not currently an allowed callback URL on dev-tnspay-iq-app-client, so
    // Cognito rejects it with a redirect_uri mismatch.
    //
    // That app client is managed by Terragrunt, so adding the callback URL by
    // hand causes drift. Decide deliberately: register it on the existing
    // client, or create a PoC-only app client.
    logoutUri: "https://d1nf8yt7799eho.cloudfront.net/logout",
  },
  checkout: {
    checkoutApi:
      "https://tljk7p4lu9.execute-api.us-east-1.amazonaws.com/dev/api/",
    hostedCheckoutEndpoint:
      "https://checkouttest.dev.paymentgateway.tnsi.com/uat/dist/index.js",
    terminalSaleEndpoint:
      "https://tljk7p4lu9.execute-api.us-east-1.amazonaws.com/dev/api/payments/terminal/sale",
  },
};
